import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "./../../axios/axios";

export const reassignTask = createAsyncThunk(
  "task/reassignTask",
  async ({ employeeIds, taskId }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await instance.post(
        `/task/portal/reassign-task`,
        { employeeIds, taskId },
        config
      );
      return data;
    } catch (error) {
      // return custom error message from backend if present
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const submitAssignInventory = createAsyncThunk(
  "task/submitAssignInventory",
  async (formData, { rejectWithValue, getState }) => {
    try {
      // Send the caller's login with the submit (thread #1585 round 16). There is
      // no axios request interceptor (src/axios/axios.js is a bare instance), so
      // this route has been reached with no identity at all. Step one of two, the
      // same order the inspection submit took (dataSlice.js): the portal sends the
      // token now; the server's login check goes on only once this is live.
      // Sending a header the server does not yet read changes nothing.
      const token = getState()?.auth?.token;
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      };
      const { data } = await instance.post(
        `/task/portal/submit-assign-inventory`,
        formData,
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getTaskType = createAsyncThunk(
  "task/getTaskType",
  async (positionsArg, { rejectWithValue }) => {
    try {
      const positionsArray = [].concat(positionsArg?.positions ?? positionsArg ?? []).filter(Boolean);
      const positionsParam =
        positionsArray.length > 1
          ? positionsArray.map((p) => encodeURIComponent(p)).join(",")
          : positionsArray[0]
            ? encodeURIComponent(positionsArray[0])
            : "";
      const url = `/task/portal/get-task-type${positionsParam ? `?positions=${positionsParam}` : ""}`;
      const { data } = await instance.get(url);
      return data;
    } catch (error) {
      // return custom error message from backend if present
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);


